var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconNext(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8.7 15.1",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#94979A",
    d: "M1.2 15.1c-.3 0-.6-.1-.8-.3-.5-.5-.5-1.2 0-1.7l5.5-5.5L.3 2C-.2 1.5-.2.8.3.3S1.5-.2 2 .3l6.4 6.4c.5.5.5 1.2 0 1.7L2 14.7c-.2.3-.5.4-.8.4z"
  })));
}

export default SvgIconNext;